<template>
    <div class="m-questionnaire-result-top">
        <h1 class="m-questionnaire-result__title t-heading-3">{{ answer.title }}</h1>
        <img class="m-questionnaire-result__image" :src="answer.image.sizes.large" :alt="answer.image.alt">
    </div>
    <div class="m-questionnaire-result-bottom">
        <h2 class="m-questionnaire-result__subtitle t-heading-4">{{ answer.subtitle }}</h2>
        <div class="m-questionnaire-result__text t-body-normal wysiwyg" v-html="answer.text"></div>
        <form class="m-questionnaire-result__form" @submit.prevent="submit">
            <div class="m-questionnaire-result__form--input">
                <label for="questionnaire__email">{{  i18n.email_label }}</label>
                <input id="questionnaire__email" type="email" v-model="email" :placeholder="i18n.email_placeholder"/>
                <button class="c-button" type="submit">{{ loading ? i18n.loading : i18n.send }}</button>
            </div>
            <div class="m-questionnaire-result__validation" v-if="error">{{ error }}</div>
        </form>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    answer: Object,
    error: String,
    loading: Boolean,
    i18n: Object,
})

const emit = defineEmits(['submit']);
const email = ref('');

function submit() {
    emit('submit', email.value);
}

</script>